<app-base-card>
    <div class="card-content">
        <div #iconCircleRef class="icon" [ngStyle]="{color: iconColor}">
            <div #iconRef>
                <app-svg-loader height="32px" [url]="iconURL"></app-svg-loader>
            </div>
        </div>
        <div *ngIf="label" class="label">{{label}}</div>
        <div *ngIf="header" class="header">{{header}}</div>
        <div *ngIf="desc" class="desc">{{desc}}</div>
    </div>
</app-base-card>

<app-primary-btn *ngIf="btnText" gradient="true" mt="24px" (click)="onClickBtn()">{{btnText}}</app-primary-btn>